import { createSlice } from '@reduxjs/toolkit';
import { appConfig } from '../../config/app.config';
import { initialState } from '../defaultState';

const screenHistorySlice = createSlice({
    name: 'ScreenHistory',
    initialState: initialState.screenHistory,
    reducers: {
        addScreenHistory: (state, action) => {
            if (!Array.isArray(state)) {
                return state;
            }
            state =
                state.length > appConfig.screenHistoryLimit
                    ? state.slice(state.length - appConfig.screenHistoryLimit, state.length)
                    : state;
            const lastState = state[state.length - 1];
            if (lastState && lastState.screen === action.payload.screen) {
                state.pop();
            }
            state = [
                ...state,
                {
                    screen: action.payload.screenName,
                    params: action.payload.params,
                },
            ];
            return state;
        },
    },
});

export const { addScreenHistory } = screenHistorySlice.actions;

export default screenHistorySlice.reducer;
